import { useQuery } from '@tanstack/react-query';
import {
  getRegistrationReviewQueue,
  getRegistrationViewUrl
} from '../requests/registrationReview.request';
import { RegistrationReviewQueueFilter } from '../types/registrationReview.types';

export const registrationReviewQueueKey = ['registration-review-queue'];

export const useRegistrationReviewQueueQuery = (filter: RegistrationReviewQueueFilter) => {
  return useQuery({
    queryKey: [...registrationReviewQueueKey, filter],
    queryFn: () => getRegistrationReviewQueue(filter),
    // The carousel keeps its own working copy; don't reshuffle it under the reviewer.
    refetchOnWindowFocus: false
  });
};

// Presigned URLs last 10 minutes on the API side; refresh well before that.
const VIEW_URL_STALE_MS = 5 * 60 * 1000;

export const useRegistrationViewUrlQuery = (fileId?: string) => {
  return useQuery({
    queryKey: ['registration-view-url', fileId],
    queryFn: () => getRegistrationViewUrl(fileId as string),
    enabled: !!fileId,
    staleTime: VIEW_URL_STALE_MS,
    refetchOnWindowFocus: false
  });
};
